'use client';

type ParamsObject = object | null;

export function checkForEqualParams(objA?: ParamsObject, objB?: ParamsObject) {
  if (!objA || !objB) return false;

  const recordA = (objA ?? {}) as Record<string, unknown>;
  const recordB = (objB ?? {}) as Record<string, unknown>;

  const objAKeys = Object.keys(recordA);
  const objBKeys = Object.keys(recordB);

  if (objAKeys.length !== objBKeys.length) return false;

  return objAKeys.every((key) => recordA[key] === recordB[key]);
}
